var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import { Helmet } from 'react-helmet';
import FormPage from './pages/FormPage';
import InitialPage from './pages/InitialPage';
import useOrientation from './util/useOrientation';
import { getFontStylesheetHref } from './util/fonts';
import { onboardingColorVariables } from './styles/onboardingPalette';
import { useTranslation } from './i18n';
import { Amplify } from 'aws-amplify';
//import '@aws-amplify/ui-react/styles.css';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);
var AppContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n"], ["\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n"])));
var GlobalThemeStyles = createGlobalStyle(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  :root {\n    ", "\n  }\n  #root,\n  body,\n  button,\n  input,\n  textarea,\n  select {\n    font-family: ", ";\n  }\n"], ["\n  :root {\n    ", "\n  }\n  #root,\n  body,\n  button,\n  input,\n  textarea,\n  select {\n    font-family: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return onboardingColorVariables(theme);
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
});
/**
 * Base path the SPA is mounted on, derived from webpack's `output.publicPath`.
 *
 * At the site root (staging/production) publicPath is "/" and this is "/", so routing is unchanged.
 * In the idCerberus Small Edition the SDK is served by the Spring Boot backend under "/sdk/", and
 * without a matching basename the browser path "/sdk/" matches no route and renders a blank page.
 */
var ROUTER_BASENAME = typeof __webpack_public_path__ === 'string' && __webpack_public_path__ !== '' ? __webpack_public_path__ : '/';
function App() {
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var i18n = useTranslation().i18n;
    var isLandscape = useOrientation();
    var fontStylesheetHref = getFontStylesheetHref(theme.fontFamily);
    var helmetLinks = fontStylesheetHref
        ? [
            { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
            { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: 'anonymous' },
            { rel: 'stylesheet', href: fontStylesheetHref },
        ]
        : [];
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(AppContainer, { isLandscape: isLandscape, screenWidth: window.innerWidth, screenHeight: window.innerHeight },
            React.createElement(Helmet, { htmlAttributes: { lang: i18n.language }, link: helmetLinks }),
            React.createElement(GlobalThemeStyles, null),
            React.createElement(Router, { basename: ROUTER_BASENAME },
                React.createElement(Routes, null,
                    React.createElement(Route, { path: "/", element: React.createElement(InitialPage, null) }),
                    React.createElement(Route, { path: "/form", element: React.createElement(FormPage, null) }))))));
}
export default App;
var templateObject_1, templateObject_2;
